<div class="bg-white p-6 rounded-lg text-center w-full font-sans">
  <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
    <svg class="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
    </svg>
  </div>
  
  <h3 class="text-lg font-bold text-gray-900 mb-2">Attention Required</h3>
  
  <p class="text-gray-600 text-sm mb-6 leading-relaxed">
    {{ errorMessage }}
  </p>
  
  <button (click)="close()" 
          class="w-full bg-[#1D4586] text-white px-6 py-2.5 rounded font-semibold text-sm hover:bg-[#16366b] transition-colors focus:outline-none">
    Understood
  </button>
</div>